export const ROOT_PATH = "/";
export const LOGIN_PATH = `${ROOT_PATH}login`;
export const PROFILE_PATH = `${ROOT_PATH}profile`;

export const CHAT_PAGE_PATH = `${ROOT_PATH}chat`;

// error
export const PAGE_403_PATH = `${ROOT_PATH}403`;
export const PAGE_404_PATH = `${ROOT_PATH}404`;
export const PAGE_500_PATH = `${ROOT_PATH}500`;

// user
export const USER_LIST_PATH = `${ROOT_PATH}user-list`;
export const ADD_USER_PATH = `${ROOT_PATH}add-user`;
export const EDIT_USER_PATH = `${ROOT_PATH}edit-user`;
export const FRAUD_DETECTION_PATH = `${ROOT_PATH}fraud-detection`;
export const TURNOVER_MANAGEMENT_PATH = `${ROOT_PATH}turnover`;

// partners
export const PARTNERS_DASHBOARD_PATH = `${ROOT_PATH}partners`;
export const ALL_PARTNERS_PATH = `${ROOT_PATH}partners/all`;
export const PARTNER_USERS_PATH = `${ROOT_PATH}partners/users`;
export const CREATE_PARTNER_PATH = `${ROOT_PATH}partners/create`;

// role
export const ROLE_LIST_PATH = `${ROOT_PATH}role-list`;
export const ADD_ROLE_PATH = `${ROOT_PATH}add-role`;
export const EDIT_ROLE_PATH = `${ROOT_PATH}edit-role`;

// banner
export const BANNER_LIST_PATH = `${ROOT_PATH}banner-list`;
export const ADD_BANNER_PATH = `${ROOT_PATH}add-banner`;
export const EDIT_BANNER_PATH = `${ROOT_PATH}edit-banner`;

// static page
export const STATIC_PAGE_LIST_PATH = `${ROOT_PATH}static-page-list`;
export const ADD_STATIC_PAGE_PATH = `${ROOT_PATH}add-static-page`;
export const EDIT_STATIC_PAGE_PATH = `${ROOT_PATH}edit-static-page`;

// site config
export const SITE_CONFIG_PATH = `${ROOT_PATH}site-config`;
export const PARTNER_SETTINGS_PATH = `${ROOT_PATH}partner-settings`;
export const PAYMENT_GATEWAY_SETTINGS_PATH = `${ROOT_PATH}payment-gateway-settings`;
export const PAYMENT_GATEWAY_TRANSACTIONS_PATH = `${ROOT_PATH}payment-gateway-transactions`;
export const SITE_CONFIG_LIST_PATH = `${ROOT_PATH}site-config-list`;
export const ADD_SITE_CONFIG_PATH = `${ROOT_PATH}add-site-config`;
export const EDIT_SITE_CONFIG_PATH = `${ROOT_PATH}edit-site-config`;

// automaticPopup
export const AUTOMATICPOPUP_LIST_PATH = `${ROOT_PATH}automaticPopup-list`;
export const ADD_AUTOMATICPOPUP_PATH = `${ROOT_PATH}add-automaticPopup`;
export const EDIT_AUTOMATICPOPUP_PATH = `${ROOT_PATH}edit-automaticPopup`;

// depositOption
export const DEPOSITOPTION_LIST_PATH = `${ROOT_PATH}depositOption-list`;
export const ADD_DEPOSITOPTION_PATH = `${ROOT_PATH}add-depositOption`;
export const EDIT_DEPOSITOPTION_PATH = `${ROOT_PATH}edit-depositOption`;

// depositRecord
export const DEPOSITRECORD_LIST_PATH = `${ROOT_PATH}depositRecord-list`;
export const ADD_DEPOSITRECORD_PATH = `${ROOT_PATH}add-depositRecord`;
export const EDIT_DEPOSITRECORD_PATH = `${ROOT_PATH}edit-depositRecord`;

// withdrawOption
export const WITHDRAWOPTION_LIST_PATH = `${ROOT_PATH}withdrawOption-list`;
export const ADD_WITHDRAWOPTION_PATH = `${ROOT_PATH}add-withdrawOption`;
export const EDIT_WITHDRAWOPTION_PATH = `${ROOT_PATH}edit-withdrawOption`;

// withdrawRecord
export const WITHDRAWRECORD_LIST_PATH = `${ROOT_PATH}withdrawRecord-list`;
export const ADD_WITHDRAWRECORD_PATH = `${ROOT_PATH}add-withdrawRecord`;
export const EDIT_WITHDRAWRECORD_PATH = `${ROOT_PATH}edit-withdrawRecord`;

// faqData
export const FAQDATA_LIST_PATH = `${ROOT_PATH}faqData-list`;
export const ADD_FAQDATA_PATH = `${ROOT_PATH}add-faqData`;
export const EDIT_FAQDATA_PATH = `${ROOT_PATH}edit-faqData`;

// Chat Template
export const CHAT_TEMPLATE_LIST_PATH = `${ROOT_PATH}chat-template-list`;
export const ADD_CHAT_TEMPLATE_PATH = `${ROOT_PATH}add-chat-template`;
export const EDIT_CHAT_TEMPLATE_PATH = `${ROOT_PATH}edit-chat-template/:id`;

// categories
export const CATEGORIES_LIST_PATH = `${ROOT_PATH}categories-list`;
export const ADD_CATEGORIES_PATH = `${ROOT_PATH}add-categories`;
export const EDIT_CATEGORIES_PATH = `${ROOT_PATH}edit-categories`;

// games
export const GAMES_LIST_PATH = `${ROOT_PATH}games-list`;
export const ADD_GAMES_PATH = `${ROOT_PATH}add-games`;
export const EDIT_GAMES_PATH = `${ROOT_PATH}edit-games`;
export const GAMEPLAY_HEALTH_PATH = `${ROOT_PATH}gameplay-health`;

// bet
export const BET_LIST_PATH = `${ROOT_PATH}bet-list`;
export const ADD_BET_PATH = `${ROOT_PATH}add-bet`;
export const EDIT_BET_PATH = `${ROOT_PATH}edit-bet`;

// language
export const LANGUAGE_LIST_PATH = `${ROOT_PATH}language-list`;
export const ADD_LANGUAGE_PATH = `${ROOT_PATH}add-language`;
export const EDIT_LANGUAGE_PATH = `${ROOT_PATH}edit-language`;

// support
export const SUPPORT_LIST_PATH = `${ROOT_PATH}support-list`;
export const ADD_SUPPORT_PATH = `${ROOT_PATH}add-support`;
export const EDIT_SUPPORT_PATH = `${ROOT_PATH}edit-support`;

// providers
export const PROVIDERS_LIST_PATH = `${ROOT_PATH}providers-list`;
export const ADD_PROVIDERS_PATH = `${ROOT_PATH}add-providers`;
export const EDIT_PROVIDERS_PATH = `${ROOT_PATH}edit-providers`;

// admin role
export const ADMIN_ROLE_LIST_PATH = `${ROOT_PATH}admin-role-list`;
export const ADD_ADMIN_ROLE_PATH = `${ROOT_PATH}add-admin-role`;
export const EDIT_ADMIN_ROLE_PATH = `${ROOT_PATH}edit-admin-role`;
export const SUB_ADMIN_LIST_PATH = `${ROOT_PATH}sub-admin-list`;
export const ADD_SUB_ADMIN_PATH = `${ROOT_PATH}add-sub-admin`;
export const EDIT_SUB_ADMIN_PATH = `${ROOT_PATH}edit-sub-admin`;

// activity log
export const ACTIVITY_LOG_LIST_PATH = `${ROOT_PATH}activity-log-list`;

// bonus
export const BONUS_LIST_PATH = `${ROOT_PATH}bonus-list`;
export const ADD_BONUS_PATH = `${ROOT_PATH}add-bonus`;
export const EDIT_BONUS_PATH = `${ROOT_PATH}edit-bonus`;
export const SPIN_CAMPAIGN_LIST_PATH = `${ROOT_PATH}spin-campaign-list`;
export const ADD_SPIN_CAMPAIGN_PATH = `${ROOT_PATH}add-spin-campaign`;
export const EDIT_SPIN_CAMPAIGN_PATH = `${ROOT_PATH}edit-spin-campaign`;
export const SPIN_ATTEMPT_LIST_PATH = `${ROOT_PATH}spin-attempt-list`;

// affiliate
export const AFFILIATE_LIST_PATH = `${ROOT_PATH}affiliate-list`;
export const ADD_AFFILIATE_PATH = `${ROOT_PATH}add-affiliate`;
export const EDIT_AFFILIATE_PATH = `${ROOT_PATH}edit-affiliate`;
export const REFERRAL_BONUS_LIST_PATH = `${ROOT_PATH}referral-bonus-list`;
export const WITHDRAW_REQUESTS_LIST_PATH = `${ROOT_PATH}withdraw-requests-list`;
export const TURNOVER_SIMULATOR_LIST_PATH = `${ROOT_PATH}turnover-simulator-list`;

// reports
export const REPORTS_LIST_PATH = `${ROOT_PATH}reports-list`;
export const REPORTS_DASHBOARD_PATH = `${ROOT_PATH}reports-dashboard`;

// channelType
export const CHANNELTYPE_LIST_PATH = `${ROOT_PATH}channelType-list`;
export const ADD_CHANNELTYPE_PATH = `${ROOT_PATH}add-channelType`;
export const EDIT_CHANNELTYPE_PATH = `${ROOT_PATH}edit-channelType`;

// user bonus
export const USER_BONUS_LIST_PATH = `${ROOT_PATH}user-bonus-list`;
export const ADD_USER_BONUS_PATH = `${ROOT_PATH}add-user-bonus`;
export const EDIT_USER_BONUS_PATH = `${ROOT_PATH}edit-user-bonus`;

// free spin
export const FREE_SPIN_LIST_PATH = `${ROOT_PATH}free-spin-list`;
export const ADD_FREE_SPIN_PATH = `${ROOT_PATH}add-free-spin`;
export const EDIT_FREE_SPIN_PATH = `${ROOT_PATH}edit-free-spin`;

// vip config
export const VIP_CONFIG_LIST_PATH = `${ROOT_PATH}vip-config-list`;
export const ADD_VIP_CONFIG_PATH = `${ROOT_PATH}add-vip-config`;
export const EDIT_VIP_CONFIG_PATH = `${ROOT_PATH}edit-vip-config`;

// bonus transaction
export const BONUS_TRANSACTION_LIST_PATH = `${ROOT_PATH}bonus-transaction-list`;

// bonus limits config
export const BONUS_LIMITS_CONFIG_LIST_PATH = `${ROOT_PATH}bonus-limits-config-list`;
export const ADD_BONUS_LIMITS_CONFIG_PATH = `${ROOT_PATH}add-bonus-limits-config`;
export const EDIT_BONUS_LIMITS_CONFIG_PATH = `${ROOT_PATH}edit-bonus-limits-config`;

// affiliate commission
export const AFFILIATE_COMMISSION_LIST_PATH = `${ROOT_PATH}affiliate-commission-list`;

// bonus report
export const BONUS_REPORT_PATH = `${ROOT_PATH}bonus-report`;

// SLUGS_EXPORTS_AREA
